import React from 'react';
import { pick } from 'Helpers/Affordances';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import IncomeDetailsRedesign from 'Components/Universal/Questionnaire/Screens/IncomeDetailsRedesign';
import IncomeDetailsLegacy from './IncomeDetailsLegacy';
import Navigator from '../UI/Navigator';

const IncomeDetails = (props) => {
  const { householdResource } = useSimpleHousehold();

  const Component = pick(householdResource, {
    [fr.relationships.incomeDetails.name]: IncomeDetailsRedesign,
  }, IncomeDetailsLegacy);

  return (
    <Navigator>
      <Component {...props} />
    </Navigator>
  );
};

export default IncomeDetails;
